"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DateHeadersFull_1 = require("./components/DateHeadersFull");
var React = require("react");
var isDateHeadersOptionDirty_1 = require("./utils/isDateHeadersOptionDirty");
var saveDateHeadersOption_1 = require("./actions/saveDateHeadersOption");
var discardDateHeadersOption_1 = require("./actions/discardDateHeadersOption");
var isDateHeaderEnabled_1 = require("./utils/isDateHeaderEnabled");
var DateHeadersOption = {
    key: 'dateHeaders',
    titleStringKey: 'optionTitle_dateHeaders',
    searchTermsStringKey: 'optionTitle_dateHeaders',
    fullOptionFormSettings: {
        render: function () { return React.createElement(DateHeadersFull_1.default, null); },
        isDirty: isDateHeadersOptionDirty_1.default,
        onSave: saveDateHeadersOption_1.default,
        onDiscard: discardDateHeadersOption_1.default,
    },
    quickOptionSettings: {
        rendering: {
            isToggleOn: isDateHeaderEnabled_1.default,
            onToggle: saveDateHeadersOption_1.default,
        },
        order: 5 /* DateHeaders */,
        workloads: 1 /* Mail */,
        customTitle: 'options_dateHeaders_quick_label',
    },
};
exports.default = DateHeadersOption;
//# sourceMappingURL=DateHeadersOption.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-date-headers-option/lib/DateHeadersOption.js
// module id = 5080
// module chunks = 2